import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry if REACT_APP_SENTRY_DSN is provided. No-op in dev
 * unless you explicitly set the env var, so local development doesn't
 * ship noise to the production project.
 *
 * Opt in:
 *   REACT_APP_SENTRY_DSN=https://…@sentry.io/123 npm start
 */
export function initSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    sendDefaultPii: false,
  });
}

export { Sentry };
